// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"Video_Wrapper__3VZPa","Video":"Video_Video__3O4h6","Poster":"Video_Poster__TtwcJ","PosterButton":"Video_PosterButton__yKJEA","Play":"Video_Play__kSd9Y"};